import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { ClonotypeDefinition, setClonotypeDefinition } from '../store/slices/preprocessing.slice';
import type { AppDispatch, AppState } from '../store/store';

export function useEnsureSelectedClonotypeDefinition() {
  const { id: experimentId } = useParams<{ id: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const defaultClonotypeDefinition = ClonotypeDefinition.HILARY;
  const selectedClonotypeDefinition = useSelector((state: AppState) => state.preprocessing[experimentId as string]?.clonotypeDefinition);

  if (!experimentId) {
    return defaultClonotypeDefinition;
  }

  if (selectedClonotypeDefinition) {
    return selectedClonotypeDefinition;
  }

  dispatch(setClonotypeDefinition({ experimentId: experimentId as string, clonotypeDefinition: defaultClonotypeDefinition }));

  return defaultClonotypeDefinition;
}
